import { C } from '@parsina/framework/tokens';

/**
 * The pre-membership brand surfaces, as the DOCTOR panel draws them.
 *
 * The doctor app is the source of truth for how signing in, the session check
 * and onboarding look (2026-09-19): a person who uses both panels must not be
 * able to tell them apart before they are inside one. These are its three
 * gradients, spelt from the navy token family rather than from hex, so an
 * accent preset recolours them exactly as it recolours the doctor's.
 *
 *   CANVAS  the page behind the card          (doctor App.jsx AuthPage, Onboarding root)
 *   HERO    the card's header band            (doctor boot hero, Onboarding header)
 *   ACTION  a solid primary on a white card   (doctor auth-error retry)
 *
 * They are NOT `GRADIENT_BRAND_DARK`: that token runs azure → deep navy at
 * 135°, which is the clinic's former look and exactly the difference this file
 * exists to remove.
 */
export const BRAND_CANVAS = `linear-gradient(145deg, ${C.navyDark} 0%, ${C.navy} 55%, ${C.navyLight} 100%)`;
export const BRAND_HERO = `linear-gradient(160deg, ${C.navyDark} 0%, ${C.navy} 60%, ${C.navyLight} 100%)`;

/** White over the brand gradient — the doctor's literals, one place. */
export const ON_BRAND = {
  tile: 'rgba(255,255,255,0.12)',
  glyph: 'rgba(255,255,255,0.85)',
  muted: 'rgba(255,255,255,0.55)',
};
